var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isInEditorMode)?_c('dr-wrapper',_vm._g(_vm._b({class:_vm.evaluateClasses(_vm.classes)},'dr-wrapper',_vm.$props,false),_vm.wrapOn),[_c('it-chart-editor',_vm._b({},'it-chart-editor',_vm.$props,false))],1):(_vm.isVisible)?_c('it-chart-component',_vm._b({},'it-chart-component',_vm.$props,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }